import React from "react";
import componentStyle from '@/styles/Component.scss';
import style from "@/pages/register/Resiger.scss";
import globalStyle from '@/styles/Global.scss'
import {UserRegister} from "@/entity/User";
import AttributeEditor from "@/components/AttributeEditor";

const ProfileEditor = ({
                         userRegister = new UserRegister({}), onChange = (userRegister = new UserRegister()) => {
  }
                       }) => {

  const updateUserRegister = (diff) => {
    onChange(new UserRegister({...userRegister, ...diff}))
  }

  return (
    <>
      <div className={componentStyle.inputArea}>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>姓</div>
          <div className={globalStyle.value}>
            <input className={style.input} value={userRegister.familyName}
                   onInput={(e) => updateUserRegister({familyName: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>名</div>
          <div className={globalStyle.value}>
            <input className={style.input} value={userRegister.firstName}
                   onInput={(e) => updateUserRegister({firstName: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>姓フリガナ</div>
          <div className={globalStyle.value}>
            <input className={style.input} value={userRegister.familyNameKana}
                   onInput={(e) => updateUserRegister({familyNameKana: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>名フリガナ</div>
          <div className={globalStyle.value}>
            <input className={style.input} value={userRegister.firstNameKana}
                   onInput={(e) => updateUserRegister({firstNameKana: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>メールアドレス</div>
          <div className={globalStyle.value}>
            {userRegister.mail}
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <AttributeEditor id={userRegister.id} edit={true}
                           onChange={(attributes) => updateUserRegister({attributes: attributes})}
                           attributes={userRegister.attributes}
                           showAutoReading={false}
          />
        </div>
      </div>
    </>
  )
}
export default ProfileEditor
